import React, { useEffect, useState } from 'react';
import { Button, Input, InputRed, LayerBottom } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const FamilySecurity = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>거주지와 주민등록번호 뒷자리를<br />입력해주세요.</h3>
				<p className="guide-title mt_20">입력한 정보는 패밀리 정보 조회를 위해서만 사용돼요!</p>

				<p className="guide-title mt_40">거주지</p>
				<div className={`${styles["select-area"]} mt_10`} onClick={openLayer}>
					<span style={{ color: "#ddd" }}>지역을 선택하세요.</span>
					<i className="icon" />
				</div>

				<p className="guide-title mt_40">주민등록번호</p>
				<div className="flex-align_center mt_10">
					<div className="flex--item_1">
						<Input type="text" placeholder="주민번호 앞 6자리" id="" maxlength="6" />
					</div>
					<span style={{ margin: "0 0.5rem" }}>-</span>
					<div className="form-group flex--item_1">
						{/* 숫자 입력 시 폰트사이즈 3rem */}
						<Input type="password" placeholder="숫자 6자리" id="" maxlength="6" style={{ paddingLeft: "2rem", letterSpacing: "1rem", paddingRight: 0 }} />
						<span className="number">2</span>
					</div>
				</div>

				<InputRed text="잘못된 주민등록번호에요. 다시 입력해주세요." show={true} />
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">다음</Button>
			</div>

			<SelectLayer show={showLayer} closeLayer={closeLayer} />
		</div>
	)
}

const SelectLayer = ({ show, closeLayer }) => {

	const [menuOpen, setMenuOpen] = useState(0)

	return (
		<LayerBottom title="지역 선택" show={show} closeLayer={closeLayer} closeButton={false} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<ul className={`${styles["area-list"]} accordion-list`}>
				<li className={menuOpen === 0 ? "active" : ""} onClick={() => setMenuOpen(0)}>
					<div className="flex-justify_between align_center">
						<p className="bold">서울</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">강남구</li>
							<li>강동구</li>
							<li>강부구</li>
							<li>강서구</li>
							<li>관악구</li>
							<li>광진구</li>
							<li>구로구</li>
							<li>금천구</li>
							<li>노원구</li>
							<li>도봉구</li>
							<li>동대문구</li>
							<li>동작구</li>
							<li>마포구</li>
							<li>서대문구</li>
							<li>서초구</li>
							<li>성동구</li>
							<li>성북구</li>
							<li>송파구</li>
							<li>양천구</li>
							<li>영등포구</li>
							<li>용산구</li>
							<li>은평구</li>
							<li>종로구</li>
							<li>중구</li>
							<li>중랑구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 1 ? "active" : ""} onClick={() => setMenuOpen(1)}>
					<div className="flex-justify_between align_center">
						<p className="bold">인천</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">중구</li>
							<li>동구</li>
							<li>미추홀구</li>
							<li>연수구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 2 ? "active" : ""} onClick={() => setMenuOpen(2)}>
					<div className="flex-justify_between align_center">
						<p className="bold">대전</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">대덕구</li>
							<li>서구</li>
						</ul>
					</div>
				</li>
			</ul>
		</LayerBottom>
	)
}

export default FamilySecurity